<template>
	<div class="iuasd70">
		<input
			type="text"
			class="input"
			:value="formatedValue"
			:placeholder="placeholder"
			:id="id"
			@click="isVisible = true"
			@focus="$emit('focus')"
			@blur="$emit('blur')"
			readonly
		/>

		<transition name="fade">
			<v-date-picker
				v-if="isVisible"
				:style="calendarStyle"
				:isInline="true"
				:mode="mode"
				:value="mode === 'range' ? value : value.start"
				:minDate="minDate"
				:maxDate="maxDate"
				@input="onInput($event)"
				v-click-outside="hideCalendar"
			/>
		</transition>
	</div>
</template>

<script>
// 3rd party calendar https://docs.vcalendar.io/api.html#date-picker-props
import { setupCalendar, DatePicker } from "v-calendar"
import "v-calendar/lib/v-calendar.min.css"
import dayjs from "dayjs"

setupCalendar({
	firstDayOfWeek: 1 // Sunday
})

export default {
	name: "j-base-date-picker",
	components: { "v-date-picker": DatePicker },

	data() {
		return {
			date: this.value,
			isVisible: false
		}
	},

	props: {
		value: {
			// Expecting date in this format "YYYY-MM-DD"
			required: true,
			default: () => {
				return {
					start: dayjs().format("YYYY-MM-DD"),
					end: dayjs().format("YYYY-MM-DD")
				}
			},
			type: Object
		},
		placeholder: {
			type: String,
			default: ""
		},
		id: {
			type: String
		},
		mode: {
			type: String,
			default: "single" // or range
		},
		calendarStyle: {
			type: String,
			default: ""
		},
		// Minimum date that user can pick
		// E.g. disallow all past dates
		minDate: {
			type: Date
		},
		// Maximum date that user can pick
		maxDate: {
			type: Date
		}
	},

	computed: {
		formatedValue() {
			if (this.mode === "range") {
				if (this.value && this.value.start && this.value.end)
					return `${dayjs(this.value.start).format("DD/MM/YYYY")} - ${dayjs(
						this.value.end
					).format("DD/MM/YYYY")}`
				else return ""
			} else {
				return `${dayjs(this.value.start).format("DD/MM/YYYY")}`
			}
		}
	},

	methods: {
		onInput(value) {
			if (this.mode === "range")
				this.$emit("input", {
					start: dayjs(value.start).format("YYYY-MM-DD"),
					end: dayjs(value.end).format("YYYY-MM-DD")
				})
			// for range value is {start: "", end: ""}
			else this.$emit("input", { start: dayjs(value).format("YYYY-MM-DD") })
		},

		hideCalendar() {
			this.isVisible = false
		}
	},
	directives: {
		"click-outside": {
			bind: function(el, binding, vNode) {
				// Provided expression must evaluate to a function.
				if (typeof binding.value !== "function") {
					const compName = vNode.context.name
					let warn = `[Vue-click-outside:] provided expression '${
						binding.expression
					}' is not a function, but has to be`
					if (compName) {
						warn += `Found in component '${compName}'`
					}

					console.warn(warn)
				}
				// Define Handler and cache it on the element
				const bubble = binding.modifiers.bubble
				const handler = e => {
					if (bubble || (!el.contains(e.target) && el !== e.target)) {
						binding.value(e)
					}
				}
				el.__vueClickOutside__ = handler

				// add Event Listeners
				document.addEventListener("click", handler)
			},

			unbind: function(el, binding) {
				// Remove Event Listeners
				document.removeEventListener("click", el.__vueClickOutside__)
				el.__vueClickOutside__ = null
			}
		}
	}
}
</script>

<style src="./index.css" scoped></style>

<style>
/* 3rd party component style rewrites */
@import "../../assets/css/tokens.css";
.c-pane-container {
	position: absolute;
	width: 100%;
	max-width: 300px;
	margin: var(--spacing1) 0;
	border-radius: var(--borderRadius1);
	border-color: var(--color7) !important;
	box-shadow: none;
	font-family: var(--fontFamily1) !important;
	z-index: 100;
}

.c-pane {
	background: var(--color5);
	border-color: var(--color0) !important;
	border-radius: var(--borderRadius1);
	min-width: auto !important;
}

/* Selected days */
.c-day-background {
	background-color: var(--color2) !important;
}
</style>
